import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';

@Component({
    selector: 'crowdfunding-fees',
    templateUrl: './crowdfunding-fees.component.html',
    styleUrls: ['./crowdfunding-fees.component.scss'],
    standalone: false
})
export class CrowdfundingFeesComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  CROWDFUNDING_FEES = CompanyFieldType.CROWDFUNDING_FEES;

  CROWDFUNDING_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT =
    CompanyFieldType.CROWDFUNDING_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT;
  parameters;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;

    this.subscriptionFacade.initForm(this, { ...this.parameters });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
